exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dd-m-quiz__question .btn_wrpr{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:40px}.dd-m-quiz__question .btn_wrpr .dd-m-button--prev{border-radius:4px;color:#7f28c4;border:3px solid #7f28c4;margin-right:40px}.dd-m-quiz__question .btn_wrpr .dd-m-button--prev:hover{background-color:#7f28c4;color:#fff}.dd-m-button--next{background-color:#000;border-radius:4px;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cde0233a","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/site/js/components/quiz/card-question.vue
// module id = 279
// module chunks = 2 11